import { ChangeEvent, ReactNode } from 'react';
import { connect, FormikContextType } from 'formik';

import {
    InputDecorator,
    Props as InputWrapperProps,
    ValidationActions,
} from 'components/layout/forms/InputWrapper';

import Component from './component';

export interface Props extends InputWrapperProps {
    formik?: FormikContextType<any>;
    name: string;
    type?: string;
    placeholder?: string;
    value?: string | number;
    onChange: (event: ChangeEvent<any>) => any;
    style?: InputStyles;
    styles?: object;
    error?: ReactNode;
    disabled?: boolean;
    validationAction?: ValidationActions;
    decoratorLeft?: InputDecorator;
    decoratorRight?: InputDecorator;
    required?: boolean
    hints?: string[];
    autoDataFillError?: {
        errorMessage: string
    };
    selectedHint?: (string) => void;
    autocomplete?: boolean;
}

export enum InputStyles {
    Primary = 'primary',
    Secondary = 'secondary',
    Outline = 'outline',
}

export enum InputTypes {
    Password = 'password',
    Text = 'text',
    Number = 'number',
}

Component.defaultProps = {
    type: 'text',
    placeholder: null,
    value: '',
    style: InputStyles.Primary,
    styles: {},
    error: null,
    disabled: false,
    validationAction: ValidationActions.Decorator,
    decoratorLeft: null,
    decoratorRight: null,
    required: false,
    autocomplete: false,
};

export default connect(Component);
